import React, { useState } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { RxDotFilled } from "react-icons/rx";
import { Carousel as ReactCarousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function Slider({ slides, setShowMedia, videos }) {
  return (
    <>
      <div className="fixed  inset-0 z-50 w-screen h-screen flex flex-col items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div onClick={e => setShowMedia(false)} className=" text-red-500 border w-fit px-3 rounded-lg my-1 hover:cursor-pointer text-left bg-white ">Close</div>
        <div className="w-1/2  h-2/3  p-4 border border-gray-500 rounded-lg  bg-white/30 backdrop-blur-md flex flex-col overflow-y-scroll gap-3">
          {slides.map((e) => (
            <img src={e} />
          ))}
          {videos.map((e) => (
            <video controls src={e} className="w-full"></video>
          ))}
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </>
  );
}

export default Slider;
